import { Loader } from '@googlemaps/js-api-loader'

type AdvancedMarkerView = google.maps.marker.AdvancedMarkerView

declare global {
	interface Window {
		_avnMapData: {
			states: State[]
			locations: Location[]
		}
	}
}

type State = {
	code: string
	position: google.maps.LatLngLiteral
}

type Location = {
	name: string
	type: string
	position: google.maps.LatLngLiteral
	code: string
}

type LocationMarker = {
	marker: AdvancedMarkerView
	location: Location
}

type StateMarker = {
	marker: AdvancedMarkerView
	state: State
}

const mapEl = document.getElementById('map')
if (mapEl) {
	const loader = new Loader({
		apiKey: 'AIzaSyDR4WWv0JRi-RrfqxpMsJPOIdT-0cSb3o0&',
		version: 'beta',
		libraries: ['marker'],
	})

	loader.load().then((google) => main(google, mapEl))
}

async function main(google: typeof globalThis.google, mapEl: HTMLElement) {
	const { AdvancedMarkerView } = google.maps.marker

	const { states, locations } = window._avnMapData

	// const collisionBehavior =
	// 	google.maps.CollisionBehavior.OPTIONAL_AND_HIDES_LOWER_PRIORITY

	const map = new google.maps.Map(mapEl, {
		zoom: 3,
		center: {
			lat: 31.35543,
			lng: 2.60372,
		},
		mapId: 'ae34ec08c6ca9c09',
		streetViewControl: false,
		mapTypeControl: false,
		fullscreenControl: false,
		disableDefaultUI: true,
	})

	const locationMarkers = locations.map((location): LocationMarker => {
		const content = buildLocationContent(location)

		const marker = new AdvancedMarkerView({
			map,
			content,
			position: location.position,
			title: location.name,
			// collisionBehavior,
		})

		marker.element!.classList.add('marker', 'location', location.type)

		return { location, marker }
	})

	const usClients = locationMarkers.filter(isClientInUnitedStates)

	const stateMarkers: StateMarker[] = states.flatMap((state) => {
		const stateClients = usClients.filter(
			(client) => client.location.code === state.code
		)

		if (stateClients.length === 0) return []

		const content = buildStateContent(state, stateClients.length)

		const marker = new AdvancedMarkerView({
			map,
			content,
			position: state.position,
			title: state.code,
			// collisionBehavior,
		})

		marker.element!.classList.add('marker', 'state')

		return { state, marker }
	})

	google.maps.event.addListener(map, 'zoom_changed', () => {
		const zoomLevel = map.getZoom() ?? 2

		if (zoomLevel >= 6.2) {
			stateMarkers.forEach(({ marker }) => hideMarker(marker))
			usClients.forEach(({ marker }) => showMarker(marker))
		} else {
			stateMarkers.forEach(({ marker }) => showMarker(marker))
			usClients.forEach(({ marker }) => hideMarker(marker))
		}
	})

	// Manually picked these because they work pretty good
	map.fitBounds({ north: 50, west: -124, south: -18, east: 153 })

	// window._dbg = { map, locationMarkers }
}

const iconHTML = `<div class="icon">
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
			<circle class="border" cx="12" cy="12" r="11" stroke-width="2" />
			<circle class="inner" cx="12" cy="12" r="8" />
		</svg>
	</div>`

function buildLocationContent(location: Location) {
	const content = document.createElement('div')

	content.innerHTML = `
		${iconHTML}
		<div class="name">
			<p>${location.name}</p>
		</div>
	`

	return content
}

function buildStateContent(state: State, clientCount: number) {
	const content = document.createElement('div')

	content.innerHTML = `
		${iconHTML}
		<div class="name">
			<p>${clientCount === 1 ? 'One client' : clientCount + ' clients'} in ${
		state.code
	}</p>
		</div>
	`

	return content
}

// Clients in the US have a state code
function isClientInUnitedStates({ location }: LocationMarker) {
	return Boolean(location.code)
}

function hideMarker(marker: AdvancedMarkerView) {
	marker.element!.classList.add('hidden')
}

function showMarker(marker: AdvancedMarkerView) {
	marker.element!.classList.remove('hidden')
}
